// Outveil: color swatches on product cards (collections, home page, etc.)
// Clicking a swatch swaps the card's main image to that color's first photo.
// The existing Dawn hover-effect CSS then shows that color's second photo on hover,
// because this script updates the same two <img> elements Dawn already hovers between.
// "First" and "second" follow the media order already set on the product page itself
// (the Liquid-rendered order below) -- not any number parsed out of the filename.
(function () {
  document.addEventListener('click', function (event) {
    var moreButton = event.target.closest('.card-color-swatch--more');
    if (moreButton) {
      var moreContainer = moreButton.closest('[data-card-color-swatches]');
      if (!moreContainer) return;
      var hiddenSwatches = moreContainer.querySelectorAll('.card-color-swatch--hidden');
      for (var h = 0; h < hiddenSwatches.length; h++) {
        hiddenSwatches[h].classList.remove('card-color-swatch--hidden');
      }
      moreButton.remove();
      return;
    }

    var swatch = event.target.closest('.card-color-swatch:not(.card-color-swatch--more)');
    if (!swatch) return;

    var container = swatch.closest('[data-card-color-swatches]');
    if (!container) return;
    var key = container.getAttribute('data-card-color-swatches');

    var dataScript = document.querySelector('script[data-card-color-media="' + CSS.escape(key) + '"]');
    var mediaWrapper = document.querySelector('[data-card-media="' + CSS.escape(key) + '"]');
    if (!dataScript || !mediaWrapper) return;

    var colorMedia;
    try {
      colorMedia = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var colorName = swatch.getAttribute('data-color-name');
    var images = colorMedia[colorName] || [];
    if (!images.length) return;

    var mainImg = mediaWrapper.querySelector('[data-card-main-image]');
    var hoverImg = mediaWrapper.querySelector('[data-card-hover-image]');

    if (mainImg && images[0]) {
      mainImg.src = images[0].url;
      mainImg.srcset = images[0].url;
      if (images[0].alt) mainImg.alt = images[0].alt;
    }

    if (hoverImg) {
      var hoverSource = images[1] || images[0];
      if (hoverSource) {
        hoverImg.src = hoverSource.url;
        hoverImg.srcset = hoverSource.url;
        if (hoverSource.alt) hoverImg.alt = hoverSource.alt;
      }
    }

    var allSwatches = container.querySelectorAll('.card-color-swatch');
    for (var i = 0; i < allSwatches.length; i++) {
      allSwatches[i].classList.remove('is-active');
    }
    swatch.classList.add('is-active');
  });
})();
